import { CarrierOption } from '../graphql/queries/getAllCarrierOptions';

export const getCarrierName = (carrierCode?: number, carrierOptions?: CarrierOption[]): string => {
    if (carrierCode === undefined || !carrierOptions) return '-';
    const carrier = carrierOptions.find(c => c.value === carrierCode);
    return carrier?.name || '-';
};

/**
 * TT 包牌分拣规则第三段，与 api-server FinalMileCarrier.toTtBaggingSortingRuleCarrierSegment 一致。
 * MIX(-1) 与 null 返回空串（不拼第三段）。
 */
const TT_BAGGING_SORTING_RULE_VALUE_TO_ALIAS: Record<number, string> = {
    0: 'SWX',
    1: 'USM',
    2: 'OTC',
    3: 'UNI',
    4: 'FDX',
    5: 'COE',
    6: 'GOF',
    8: 'DHL',
    10: 'SDX',
};

/** 未在缩写表中的枚举名，与 Kotlin FinalMileCarrier.name 一致 */
const TT_BAGGING_SORTING_RULE_VALUE_TO_ENUM_NAME: Record<number, string> = {
    7: 'BETTER_TRUCKS',
    9: 'DOORDASH',
    11: 'UPS',
    12: 'VEHO',
    13: 'GOBOLT',
    14: 'CDL',
    15: 'INTERNATIONAL_BRIDGE',
    16: 'EASYPOST_ONTRAC_VIRTUAL',
    17: 'LINKTRANS',
    18: 'PACTRACK',
    19: 'PONCE',
};

export function ttBaggingSortingRuleCarrierSegment(carrierCode: number | undefined | null): string {
    if (carrierCode == null || carrierCode === -1) return '';
    const alias = TT_BAGGING_SORTING_RULE_VALUE_TO_ALIAS[carrierCode];
    if (alias) return alias;
    const enumName = TT_BAGGING_SORTING_RULE_VALUE_TO_ENUM_NAME[carrierCode];
    if (enumName) return enumName;
    return '';
}

/** 新建 TT 包牌表单里「尾程 ALL」选项的 value，与后端 MIX 对应 */
export const TT_BAG_FORM_CARRIER_ALL = 'ALL';

/**
 * 表单尾程下拉值 → 分拣规则第三段（与 Bag.computeSortingRule 一致）。
 * 选 ALL 或未选时第三段为空。
 */
export function ttBagSortingRuleCarrierSegmentFromSelect(
    carrierFormValue: string | number | undefined | null
): string {
    if (carrierFormValue === undefined || carrierFormValue === null) return '';
    if (carrierFormValue === TT_BAG_FORM_CARRIER_ALL) return '';
    if (typeof carrierFormValue === 'number') return ttBaggingSortingRuleCarrierSegment(carrierFormValue);
    return '';
}

